import FingerprintJS from '@fingerprintjs/fingerprintjs';

let cachedFingerprint: string | null = null;

export const getFingerprint = async (): Promise<string> => {
	if (cachedFingerprint) return cachedFingerprint;
	cachedFingerprint = localStorage.getItem("visitor_id");
	if (cachedFingerprint) return cachedFingerprint;

	const fp = await FingerprintJS.load();
	const result = await fp.get();

	cachedFingerprint = result.visitorId;
	localStorage.setItem("visitor_id", cachedFingerprint);
	return cachedFingerprint;
};